// extracted by mini-css-extract-plugin
export var pageTitle = "tool-module--pageTitle--3pbuK";
export var pageTitle_decoration_1 = "tool-module--pageTitle_decoration_1--3XTXH";
export var tool = "tool-module--tool--5GeUv";
export var tool__box = "tool-module--tool__box--20lAf";
export var tool__box_inner = "tool-module--tool__box_inner--3kKYy";
export var tool__box_inner_row = "tool-module--tool__box_inner_row--2U2HM";
export var tool__textarea_img_pc = "tool-module--tool__textarea_img_pc--k55_4";
export var tool__textarea = "tool-module--tool__textarea--2xSxq";
export var tool__textarea_subtitle = "tool-module--tool__textarea_subtitle--1UGsK";
export var tool__textarea_title = "tool-module--tool__textarea_title--1yqcz";
export var tool__textarea_text_pc = "tool-module--tool__textarea_text_pc--2GkMq";
export var tool__textarea_text_sp = "tool-module--tool__textarea_text_sp--37u5_";
export var tool__textarea_img_sp = "tool-module--tool__textarea_img_sp--1_a-2";
export var tool__textarea_img_sp__1 = "tool-module--tool__textarea_img_sp__1--ygYH5";
export var tool__textarea_img_sp__2 = "tool-module--tool__textarea_img_sp__2--3ycXt";
export var tool__textarea_img_sp__3 = "tool-module--tool__textarea_img_sp__3--132FO";
export var tool__textarea_img_sp__4 = "tool-module--tool__textarea_img_sp__4--2spWq";
export var tool__space = "tool-module--tool__space--20Mta";
export var tool__textarea_icon = "tool-module--tool__textarea_icon--3yH5S";
export var others = "tool-module--others--6R1ny";